<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ "5G CPE" }} {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <button type="button" @click.stop="showSmallModal = true" class="action-button">{{ $t('create_new') }}</button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th :class="'w20p'" @click="toggleSort('cpe', 'imsi')">
              IMSI
              <span v-if="sortStates.cpe.find(col => col.id === 'imsi').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'imsi').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th :class="'w20p'" @click="toggleSort('cpe', 'msisdn')">
              MSISDN
              <span v-if="sortStates.cpe.find(col => col.id === 'msisdn').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'msisdn').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('cpe', 'state')">
              {{ $t('state') }}
              <span v-if="sortStates.cpe.find(col => col.id === 'state').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'state').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('cpe', 'nb_ip')">
              NB_IP
              <span v-if="sortStates.cpe.find(col => col.id === 'nb_ip').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'nb_ip').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('cpe', 'latitude')">
              Latitude
              <span v-if="sortStates.cpe.find(col => col.id === 'latitude').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'latitude').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w15p" @click="toggleSort('cpe', 'longitude')">
              Longitude
              <span v-if="sortStates.cpe.find(col => col.id === 'longitude').order">
                <img v-if="sortStates.cpe.find(col => col.id === 'longitude').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th v-show="!getIsMobile()" class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cpe in paginatedData" :key="cpe.id" :style="!(cpe.latitude && cpe.longitude) ? { background: '#EBEBEB' } : {}" @click.stop="editCpe(cpe)">
            <td :title="cpe.imsi" :class="'w20p'" style="text-align: left;">
              {{ cpe.imsi }}
            </td>
            <td :title="cpe.msisdn" :class="'w20p'" style="text-align: left;">
              {{ cpe.msisdn }}
            </td>
            <td v-show="!getIsMobile()" :title="cpe.state" class="w15p">
              {{ cpe.state }}
            </td>
            <td v-show="!getIsMobile()" :title="cpe.nb_ip" class="w15p">
              {{ cpe.nb_ip }}
            </td>
            <td v-show="!getIsMobile()" :title="cpe.latitude" class="w15p">
              {{ cpe.latitude }}
            </td>
            <td v-show="!getIsMobile()" :title="cpe.longitude" class="w15p">
              {{ cpe.longitude }}
            </td>
            <td v-show="!getIsMobile()" class="w10p">
              <img @click.stop="editCpe(cpe)" src="@/assets/images/edit.svg" :title="$t('modify')"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <!-- #region 장치 개별 관리 모달 -->
    <div v-show="showSmallModal" class="modal-body-content-modal-background">
      <div class="modal-body-content-modal">
        <div class="modal-body-edit-box">
          <div class="modal-body-edit-box-title">
            <h2>{{ isEditing ? $t('modify_device') : $t('add_device') }}</h2>
            <img src="@/assets/images/x_black.svg" @click="resetForm()"/>
          </div>
          <div class="modal-body-edit-box-content">
            <div class="modal-body-edit-box-content-main">
              <table>
                <tbody>
                  <tr>
                    <th>IMSI</th>
                    <td><input v-model="imsi" :placeholder="$t('enter_your_device_id')" required :disabled="isEditing" /></td>
                  </tr>
                  <tr>
                    <th>MSISDN</th>
                    <td><input v-model="msisdn" :placeholder="$t('enter_your_device_name')" required :disabled="isEditing" /></td>
                  </tr>
                  <tr>
                    <th>NB_IP</th>
                    <td><input v-model="nb_ip" :placeholder="$t('enter_your_device_name')" required :disabled="isEditing" /></td>
                  </tr>
                  <tr>
                    <th>Latitude</th>
                    <td><input v-model="latitude" placeholder="위도를 입력하세요" required /></td>
                  </tr>
                  <tr>
                    <th>Longitude</th>
                    <td><input v-model="longitude" placeholder="경도를 입력하세요" required /></td>
                  </tr>
                </tbody>
              </table>
              <div style="width: 100%; height: 300px; border-radius: 8px;" id="cpeMap"></div>
              <div class="button-group">
                <button type="button" @click.stop="resetForm()" class="cancel-button">{{ $t('cancel') }}</button>
                <button type="button" @click.stop="saveCpe(isEditing)" class="action-button">{{ $t('submit') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, watch, nextTick } from 'vue';
import L from 'leaflet';
import { SERVER_REQUEST } from '../utils/ServerConnect';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedCpeList, sortStates, toggleSort } from '@/utils/SortUtility';
import { getIsMobile } from '@/utils/GlobalUtility';
import { showSmallModal } from '@/utils/ModalUtility';
import { defaultLocation, firstMapSetting, numberAndCloseMarker } from '@/utils/MapSetting';

const imsi = ref(null);
const msisdn = ref(null);
const nb_ip = ref(null);
const latitude = ref(null);
const longitude = ref(null);
let isEditing = false;
const nowSelectedCpe = ref();
const cpeMap = ref(null);
const cpeMarker = ref(null);

const saveCpe = async (check) => {
  if (!imsi.value || !msisdn.value || !nb_ip.value) {
    showNotification('Enter information.', 'warn', 'top-center');
    return;
  }

  if (!(imsi.value.startsWith("00101000001") || imsi.value.startsWith("001010000001"))) {
    showNotification('IMSI format does not match.', 'warn', 'top-center');
    return;
  }

  const totalData = {
    imsi: imsi.value,
    lat: latitude.value,
    lng: longitude.value,
  }
  const jsonData = JSON.stringify(totalData);
  loadingStore.showLoading();
  await SERVER_REQUEST('ptts', check ? 'PUT' : 'POST', jsonData, false, { 'Content-Type': 'application/json' }, '/ue');
  loadingStore.hideLoading();
  resetForm();
};

const editCpe = (cpe) => {
  nowSelectedCpe.value = cpe;
  showSmallModal.value = true;
  imsi.value = cpe.imsi;
  msisdn.value = cpe.msisdn;
  nb_ip.value = cpe.nb_ip;
  
  if (cpe.latitude && cpe.longitude) {
    addPin({lat: cpe.latitude, lng: cpe.longitude});
    cpeMap.value.setView({ lat: cpe.latitude, lng:cpe.longitude })
  } else {
    if (cpeMarker.value) cpeMap.value.removeLayer(cpeMarker.value);
    cpeMap.value.setView(defaultLocation.value)
  }
  isEditing = true;
};

const resetForm = () => {
  nowSelectedCpe.value = null;
  showSmallModal.value = false;
  imsi.value = null;
  msisdn.value = null;
  nb_ip.value = null;
  latitude.value = null;
  longitude.value = null;
  isEditing = false;

  if (cpeMarker.value) {
    cpeMap.value.removeLayer(cpeMarker.value);
    cpeMarker.value = null;
  }
};

// 핀 추가 및 폴리곤 업데이트
const addPin = (latlng) => {
  if (!cpeMap.value) return; // 지도가 초기화되지 않았을 경우 추가 방지
  if (cpeMarker.value) cpeMap.value.removeLayer(cpeMarker.value);

  const customIcon = numberAndCloseMarker(`<img src="${new URL("@/assets/images/simsys/circle_5gcpe_gray.svg", import.meta.url).href}" style="width: 40px; height: 40px;" />`);

  const marker = L.marker(latlng, { icon: customIcon, lat: latlng.lat, lng: latlng.lng, type: 'numberPin', draggable: true }).addTo(cpeMap.value);
  latitude.value = latlng.lat;
  longitude.value = latlng.lng;

  const closeBtn = marker.getElement().querySelector('button');
  // 드래그 방지: 마커 드래그 이벤트로 전달되지 않도록
  closeBtn.addEventListener('mousedown', (e) => e.stopPropagation());
  closeBtn.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
  // 'X' 버튼 클릭 시 마커 삭제
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation(); // 클릭 이벤트 전파 방지 (지도 클릭으로 인식되는 것 방지)
    latitude.value = null;
    longitude.value = null;
    cpeMap.value.removeLayer(marker);
  });

  // 드래그가 끝났을 때 폴리곤 다시 생성
  marker.on('dragend', (event) => {
    const { lat, lng } = event.target.getLatLng()
    latitude.value = lat;
    longitude.value = lng;
  })
  cpeMarker.value = marker;
};

onMounted(async () => {
  cpeMap.value = await firstMapSetting('cpeMap', 17);
  // 지도 클릭 이벤트
  cpeMap.value.on('click', function (e) {
    if (cpeMap.value) {
      addPin(e.latlng); // map이 존재할 때만 마커 추가
    }
  });
  await nextTick();
  cpeMap.value.invalidateSize();
});

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedCpeList.value.filter(cpe =>
  String(cpe.nb_ip).toLowerCase().includes(query) // IP로 검색
    || String(cpe.state).toLowerCase().includes(query) // 으로 검색
    || String(cpe.imsi).toLowerCase().includes(query) // 으로 검색
    || String(cpe.msisdn).toLowerCase().includes(query) // 로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);

watch(showSmallModal, async () => {
  await nextTick();
  cpeMap.value.invalidateSize();
});
</script>